import React from "react"

const Tag = ({ text = '' }) => {
    return <div className="mpp_qp_tag">
        <span className="mpp_qp_tag_text">{text}</span>
    </div>
}

export default Tag;